"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonControl = void 0;
var _Fab2 = _interopRequireDefault(require("@mui/material/Fab"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ButtonControl {
  constructor(id, options, callback) {
    this.id = id;
    this.options = options;
    this.callback = callback;
  }
  onAdd(_map) {
    this.map = _map;
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl';
    const content = document.createElement('div');
    content.id = this.id;
    this.container.appendChild(content);
    this.root = (0, _client.createRoot)(this.container);
    return this.container;
  }
  init(theme) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.theme = theme;
    this.update(options);
  }
  update() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    if (!this.theme) return;
    const {
      ariaControls,
      ariaHasPopup,
      title,
      tooltipPlacement,
      color,
      icon,
      size,
      variant
    } = this.options = {
      ...this.options,
      ...options
    };
    if (callback) this.callback = callback;
    if (!this.root) return;
    this.root.render( /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
      theme: this.theme
    }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
      theme: this.theme
    }, variant === 'extended' ? /*#__PURE__*/_react.default.createElement(StyledFab, {
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHasPopup,
      color: color,
      onClick: event => this.map ? this.callback(this.map, event) : undefined,
      size: size || 'small',
      style: {
        textTransform: 'initial'
      },
      variant: "extended"
    }, icon, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        marginLeft: 8
      }
    }, title)) : /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
      placement: tooltipPlacement || 'left',
      title: title
    }, /*#__PURE__*/_react.default.createElement(StyledFab, {
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHasPopup,
      "aria-label": title,
      color: color,
      onClick: event => this.map ? this.callback(this.map, event) : undefined,
      size: size || 'small'
    }, icon)))));
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
exports.ButtonControl = ButtonControl;
const StyledFab = (0, _styledComponents.default)(_Fab2.default)`
  && {
    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary) {
      background-color: #fff;
    }

    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary):hover {
      background-color: #d5d5d5;
    }

    &.MuiFab-primary:hover {
      background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.palette.primary.dark;
}};
    }

    &.MuiFab-secondary:hover {
      background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.secondary.dark;
}};
    }
  }
`;